import { transition } from '@helpers/animate';
import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { contentStyles, h4, paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import styled from 'styled-components';
const Wrapper = styled.article `
  display: flex;
  overflow: hidden;
  height: 100%;

  &[data-site='ess'] {
    --colorTitle: ${brand.ess.primary};
    --colourText: ${brand.ess.secondary.darkGrey};

    --dateBgColour: ${brand.ess.secondary.lightestGrey};
    --dateTextColour: ${brand.ess.secondary.darkGrey};

    [data-background='dark'] & {
      --colorTitle: ${brand.global.white};
      --colourText: ${brand.global.white};
    }
  }

  &[data-site='mep'] {
    --colorTitle: ${brand.mep.primary};
    --colourText: ${brand.mep.primary};

    --dateBgColour: ${brand.mep.secondary.lightestGrey};
    --dateTextColour: ${brand.mep.secondary.darkestGrey};
  }
`;
const Container = styled.div `
  a& {
    display: block;
    width: 100%;
    text-decoration: none;

    .focus-ring & {
      outline: auto;
      outline-offset: 3px;
      outline-width: 2px;
      outline-style: solid;
    }
  }
`;
const ImageContainer = styled.div `
  ${imageWrapperPreserveRatio(429, 268)};

  margin-bottom: ${fluid(22, 28)};
  overflow: hidden;

  [data-site='mep'] & {
    border-radius: 8px;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
  ${transition('transform', 0.6)};

  ${Container}[data-has-link].focus-ring &,
  ${Container}[data-has-link]:hover & {
    transform: scale(1.05);
  }
`;
const Date = styled.time `
  ${paragraphSmall};

  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  margin-bottom: 12px;
  line-height: 1;
  height: ${fluid(22, 24)};
  background-color: var(--dateBgColour);
  color: var(--dateTextColour);

  [data-site='mep'] & {
    border-radius: 6px;
  }
`;
const Title = styled.h4 `
  ${h4};

  color: var(--colorTitle);
  margin-bottom: ${fluid(20, 28)};

  [data-site='mep'] & {
    ${fonts.museoSlab.medium};
  }
`;
const Content = styled.div `
  ${contentStyles};

  color: var(--colourText);
  margin-bottom: ${fluid(24, 28)};
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;

  [data-site='mep'] & {
    -webkit-line-clamp: 2;
  }
`;
const LinkContainer = styled.div `
  padding-bottom: 2px;

  ${Container}:hover &,
  ${Container}.focus-ring & {
    /* ${ButtonStyles.Container} {
      text-decoration-color: var(--colourTextDecorationActive);
    } */

    ${ButtonStyles.IconWrapper} {
      transform: translateX(15%);
    }
  }
`;
const ArticleCardStyles = {
    Wrapper,
    Container,
    ImageContainer,
    Image,
    Date,
    Title,
    Content,
    LinkContainer,
};
export default ArticleCardStyles;
